import Vue from 'vue';
import Router from 'vue-router';
import { Role } from '@/utils/auth';

import NotFoundPage from '@/pages/NotFound.vue';
// eslint-disable-next-line import/no-cycle
import store from '@/store';
// eslint-disable-next-line import/no-cycle
import Root from '@/router/modules/root';
// eslint-disable-next-line import/no-cycle
import Dashboard from '@/router/modules/dashboard';
import COURSE_PROMOTION_ROUTES from './coursePromotionRoutes';

const ProfilePage = () => import(/* webpackChunkName: "group-profile" */ '@/pages/ProfilePage');
const Post = () => import(/* webpackChunkName: "group-profile" */ '@/pages/post/Post.vue');
const MailchimpOAuth = () => import(/* webpackChunkName: "group-other" */ '@/pages/MailchimpOAuth.vue');
const NoteView = () => import(/* webpackChunkName: "group-other" */ '@/pages/NoteView.vue');
const PaymentSuccess = () => import(/* webpackChunkName: "group-profile" */ '@/pages/PaymentSuccess.vue');
const PickPlanPage = () => import(/* webpackChunkName: "group-payment" */ '@/pages/pricingPage/PickPlanPage');
const StripeCheckoutPage = () => import(/* webpackChunkName: "group-payment" */ '@/pages/StripeCheckoutPage/StripeCheckoutPage');
const GetStartedPage = () => import(/* webpackChunkName: "group-profile" */ '@/components/GetStartedPage/GetStartedPage');

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    Root,
    Dashboard,
    {
      path: '/e/pick-your-plan',
      name: 'PlanPicker',
      component: PickPlanPage,
    },
    {
      path: '/e/get-started',
      name: 'GetStarted',
      component: GetStartedPage,
    },
    {
      path: '/e/checkout',
      name: 'CheckoutChoosePaymentMethod',
      component: StripeCheckoutPage,
    },
    ...COURSE_PROMOTION_ROUTES,
    {
      path: '/product/:id',
      name: 'Post',
      component: Post,
      props: true,
    },
    {
      path: '/oauth/mailchimp',
      name: 'MailchimpOAuth',
      component: MailchimpOAuth,
    },
    {
      path: '/note/:id',
      name: 'Note',
      component: NoteView,
    },
    {
      path: '/payment/success',
      name: 'payment.success',
      component: PaymentSuccess,
    },
    {
      path: '/@:username',
      redirect: (to) => {
        const { params, query } = to;
        return { path: `/${params.username}`, query };
      },
    },
    {
      path: '/:username([a-zA-Z0-9\\-_\\.]+)',
      name: 'Profile',
      component: ProfilePage,
      props: true,
    },
    {
      path: '*',
      name: '404',
      component: NotFoundPage,
    },
  ],
});

router.beforeEach(async (to, from, next) => {
  if (window.location.host === 'foodtryb.com') {
    const path = window.location.pathname;

    if (path.startsWith('/dashboard')) {
      window.location.href = 'https://tryb.cc/dashboard';
    } else {
      window.location.href = `https://tryb.cc${path}`;
    }
  }

  const role = store.getters['auth/role'];

  if (role === Role.ADMIN) {
    return next();
  }

  const { matched } = to;
  const isAuthenticated = store.getters['auth/isAuthenticated'];
  const isUserSupporter = store.getters['user/isUserSupporter'];
  const requiresAuthRoute = matched.find(record => record.meta.requiresAuth);
  const isSupporterShouldBeRoute = matched.find(record => record.meta?.isSupporterShouldBe !== undefined);

  if (requiresAuthRoute) {
    if (!isAuthenticated) {
      return next({ name: 'SignIn' });
    }
  }

  if (isSupporterShouldBeRoute) {
    const {
      isSupporterShouldBe,
    } = isSupporterShouldBeRoute.meta;
    const shouldCorrectRoute = (isSupporterShouldBe && !isUserSupporter) || (!isSupporterShouldBe && isUserSupporter);

    if (shouldCorrectRoute) {
      if (isUserSupporter) {
        return next({ name: 'SupporterDashboard' });
      }
      return next({ name: 'Dashboard' });
    }
  }

  const protectedRoute = matched.find(record => record.meta.allowed);

  if (protectedRoute) {
    if (!protectedRoute.meta.allowed.includes(role)) {
      return next({ name: 'Homepage' });
    }
  }

  return next();
});

export default router;
